






import {Vue, Component, Prop} from 'vue-property-decorator';
import {ORDER_STATUS, orderStatusConfig} from '@/common';
@Component({
    components: {
    },
})
export default class OrderStatusAlert extends Vue {
    @Prop({default: ''})
    public status!: string;
    @Prop({default: ''})
    public callToAction!: string;

    public get config() {
        return orderStatusConfig[this.status];
    }
}
